Ext.define('SA.view.Checkbox', {
    alias: 'widget.sa-checkbox',
    extend: 'SA.view.CheckField',

    ariaRole: 'checkbox',
    baseCls: 'sa-checkbox',

    onLabelClick() {
        this.setChecked(!this.isChecked());
    }
});
